export default "__VITE_ASSET__C9o2M0U1__"